import { asContainer } from 'lib/container'
import { getDescription } from 'lib/getDescription'
import { getTitle } from 'lib/getTitle'

import { components } from 'components/DefaultMdxComponents'
import { Doc } from 'components/Layout'

import Content from './Content.mdx'

const content = Content({ components })

export const container = asContainer()({
	path: '/docs/fintech-bridges/android',
	title: getTitle(content),
	navTitle: 'Android',
	description: getDescription(content),
	authentication: { type: 'public' },
	Running: () => <Doc>{content}</Doc>,
})
